module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro4.8d1f19ce.mp3";